// OAuth configuration for Cognito Hosted UI
export const COGNITO_DOMAIN = 'ringen-web.auth.us-east-2.amazoncognito.com'
export const COGNITO_CLIENT_ID = '7ikq5dak34qqeoq8eqeast5k18'

// Build OAuth URL for Google sign-in
export function buildGoogleOAuthURL(redirectUri: string): string {
  const params = new URLSearchParams({
    client_id: COGNITO_CLIENT_ID,
    response_type: 'code',
    scope: 'openid email profile aws.cognito.signin.user.admin',
    redirect_uri: redirectUri,
    identity_provider: 'Google',
  })

  return `https://${COGNITO_DOMAIN}/oauth2/authorize?${params.toString()}`
}

// Parse callback URL to extract authorization code
export function parseOAuthCallback(url: string): { code?: string; error?: string } {
  const params = new URLSearchParams(new URL(url).search)
  const code = params.get('code')
  const error = params.get('error')

  return { code: code || undefined, error: error || undefined }
}
